import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
//#region src/mappers/toPropertyActions.ts
var i = 21, a = (n) => n.map((n) => ({
	id: `${e.PropertyDraft}:${n.id}`,
	type: e.PropertyDraft,
	intent: t.Opportunity,
	params: {
		step: n.current_step,
		totalSteps: 21
	},
	object: [n.address_city, n.address_country].filter(Boolean).join(", ") || void 0,
	createdAt: n.updated_at,
	target: {
		kind: r.PropertyDraft,
		id: n.id
	}
})), o = (i) => i.filter((e) => e.suspended_listings_count > 0).map((i) => ({
	id: `${e.ListingSuspended}:${i.id}`,
	type: e.ListingSuspended,
	intent: t.Blocker,
	imageUrl: i.images?.[0],
	params: { count: i.suspended_listings_count },
	object: i.listing_title ?? i.address,
	facets: [{
		kind: n.Count,
		count: i.suspended_listings_count
	}],
	target: { kind: r.Properties }
}));
//#endregion
export { i as PROPERTY_DRAFT_TOTAL_STEPS, a as toPropertyDraftActions, o as toSuspendedListingActions };
